angular.module('core')
  .directive('resolveScroll', ['$timeout', '$rootScope', function ($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function($scope, $element) {

        var $ps = $element.closest('.ps-container');
        var promise = null;
        var $dropdown = $element.parent();

        var disableScroll = function() {
          $ps.perfectScrollbar('destroy');
        };

        var enableScroll = function() {
          $ps.perfectScrollbar( {
            wheelSpeed: $rootScope.perfectScrollbarSpeed,
            wheelPropagation: true,
            minScrollbarLength: 20,
            suppressScrollX: true
          });
        };

        var enableScrollWithTimeout = function() {

          if( promise ) {
            $timeout.cancel(promise);
          }
          promise = $timeout(function() { enableScroll(); }, 800);
        };

        var enableTouchMoveWithTimeout = function() {
          if($dropdown.hasClass('open')) {
            disableScroll();
          }
          enableScrollWithTimeout();
        };

        var disableTouchMoveOnDropdownClick = function() {
          if($rootScope.mobile) {
            disableScroll();
            enableScrollWithTimeout();
          }
        };

        $dropdown.on('click', disableTouchMoveOnDropdownClick);

        $element.on('mouseenter', disableScroll);
        $element.on('mouseleave', enableScroll);
        $element.on('mousemove', enableScrollWithTimeout);
        $element.on('touchmove', enableTouchMoveWithTimeout);

      }
    };
  }]);
